/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Modal,
  Typography,
  Divider,
} from 'antd';
import {
  DeleteOutlined,
  EditOutlined,
} from '@ant-design/icons';
import NumericInput from 'components/NumericInput';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import toCurrency from 'utils/toCurrency';
import Select from 'components/Select';

const { Text } = Typography;

const ResumenCerrarCorte = ({
  metodos,
  setOtrasFormasDePago: setData,
  otrasFormasDePago: data,
}) => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);

  const [metodosDePago, setMetodosDePago] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [datoPago, setDatoPago] = useState([]);

  const setValues = () => {
    if (metodos?.length) {
      setMetodosDePago(metodos);
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setValues();
    }
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    form.resetFields();
    setVisible(false);
    setIsEditing(false);
  };

  const onFinish = async () => {
    await form.validateFields();
    const values = form.getFieldsValue();
    const clone = [...data];
    if (isEditing) {
      const res = clone
        .map((item) => (item.key === datoPago ? { ...values, key: datoPago } : item));
      setData(res);
    } else {
      clone.push({
        ...values,
        key: clone.length,
      });
      setData(clone);
    }
    setVisible(false);
    setIsEditing(false);
    form.resetFields();
  };

  const onClickEdit = (id) => {
    setIsEditing(true);
    setDatoPago(id);
    const record = data.find((item) => item.key === id);
    form.setFieldsValue(record);
    setVisible(true);
  };

  const onClickDelete = (id) => {
    setDatoPago(id);
    setVisibleAlert(true);
  };

  const deleteItem = () => {
    const clone = [...data].filter((item) => item.key !== datoPago);
    const normalized = clone.map((item, key) => ({ ...item, key }));
    setData(normalized);
    setVisibleAlert(false);
    onCancel();
  };

  const rules = {
    required: [{ required: true }],
  };

  const sortMethods = () => {
    const clone = [...data];
    const sorted = metodos.map((m) => ({
      ...m,
      disabled: !!clone.find((i) => (i.metodos_de_pago === m.id)),
    })).sort((a, b) => a.disabled.toString().localeCompare(b.disabled.toString()));
    setMetodosDePago(sorted);
  };

  useEffect(() => {
    sortMethods();
    // eslint-disable-next-line
  }, [data]);

  return (
    <>
      <Row align="end">
        <Button onClick={() => setVisible(true)}>
          Agregar Otros Tipos de Pago
        </Button>
      </Row>

      <br />
      <Row gutter={10}>
        <Col span={10}>
          <Text style={{ fontSize: 17 }}>
            Método
          </Text>
        </Col>
        <Col span={10}>
          <Text style={{ fontSize: 17 }}>
            Importe
          </Text>
        </Col>
        <Divider style={{ margin: '12px 0px' }} />
      </Row>
      {data.map((item) => (
        <Col
          span={24}
          key={item.key}
          style={{ background: item.key % 2 ? '#FFFFFFF' : '#F8F8F8', padding: '5px 0px' }}
        >
          <Row>
            <Col span={10}>
              <Text>
                {metodosDePago.find((i) => i.id === item.metodo_de_pago)?.concepto}
              </Text>
            </Col>
            <Col span={10}>
              <Text>{item.importe ? toCurrency(item.importe) : ''}</Text>
            </Col>
            <Col span={4}>
              <Row>
                <Col xs={24} sm={24} md={12}>
                  <Button
                    type="link"
                    className="bolded"
                    icon={<EditOutlined />}
                    onClick={() => {
                      onClickEdit(item.key);
                    }}
                  />
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <Button
                    className="danger bolded"
                    icon={<DeleteOutlined />}
                    type="link"
                    onClick={() => {
                      onClickDelete(item.key);
                    }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      ))}
      <Modal
        visible={visible}
        closable={false}
        footer={null}
        title={(
          <FormSubmitControls
            label={`${isEditing.length ? 'Editar' : 'Agregar'} Metodo de Pago`}
            onFinish={onFinish}
            onCancel={onCancel}
          />
        )}
        onCancel={onCancel}
        forceRender
      >
        <Col span={24}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
          >
            <Row gutter={10}>
              <Col span={24}>
                <Form.Item
                  label="Método de pago"
                  name="metodo_de_pago"
                  rules={rules.required}
                >
                  <Select dataSource={metodosDePago} labelProp="concepto" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <NumericInput
                  name="importe"
                  label="Importe"
                  decimal
                  required
                  currency
                />
              </Col>
            </Row>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Col>
      </Modal>
      <ModalDelete
        onDelete={deleteItem}
        onCancel={() => setVisibleAlert(false)}
        visible={visibleAlert}
        content={(
          <>
            <Text style={{ fontSize: 16 }}>
              ¿Desea eliminar el Método de Pago
              {' '}
              {metodosDePago
                .find((e) => e.id === form.getFieldValue('metodos_de_pago'))?.concepto}
              ?
            </Text>
          </>
        )}
      />
    </>
  );
};

export default ResumenCerrarCorte;
